import { MutationTree } from 'vuex';
import { IWorkOrderTemplateState } from '@/types';

export const templateMutations: MutationTree<IWorkOrderTemplateState> = {
  setWorkOrderTemplates: (state, templates) => {
    state.templates = templates;
  },
};
